import React, { useState } from "react";
import ReactDOM from "react-dom";
import "antd/dist/antd.css";
// import "./index.css";
import { Drawer, Button, Space, Radio } from "antd";
import { NavLink } from "react-router-dom";
import { useLocation } from "react-router-dom";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import meraDoc from "assets/images/meradoc.png";
import { logout } from "service/helpers/utilities";
import { useDispatch } from "react-redux";
import { restrictionURL } from "action/home";

const MobileDrawer = ({ visible, onClose }) => {
  const navLink = [
    {
      to: "/doctor/dashboard",
      label: "Dashboard",
      //   iconName: Dashboard,
      //   activeIcon: Dashboard,
    },

    {
      to: "/doctor/appointment-list",
      label: "Appointment list",
      //   iconName: appointment,
      //   activeIcon: appointment,
    },
    {
      to: "/doctor/availability",
      label: "Availability",
      //   iconName: activeAvailable,
      //   activeIcon: activeAvailable,
    },
    {
      to: "/doctor/my-profile",
      label: "My Profile",
      // iconName: activeProfile,
      // activeIcon: activeProfile,
    },

    {
      to: "/doctor/settings",
      label: "Settings",
      // iconName: activeSettings,
      // activeIcon: activeSettings,
    },
  ];

  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(0);
  const dispatch = useDispatch();
  const logoutUser = () => {
    logout()
    dispatch(restrictionURL("", true))
  }

  return (
    <>
      <Drawer
        placement={"left"}
        width={200}
        onClose={() => onClose(false)}
        visible={visible}
      >
        <div>
          <img src={meraDoc} style={{ width: "100%" }} />
        </div>
        <div>
          <List style={{ textDecoration: "none" }}>
            {navLink.map(
              ({ to, label, iconName, activeIcon, nestedChild }, index) => (
                <>
                  <NavLink
                    key={index}
                    to={to}
                    onClick={
                      to !== "/something" ? () => setActiveIndex(index) : ""
                    }
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    <div
                    //   style={{
                    //     borderRight:
                    //       location.pathname === to ? "5px solid #0E69C2" : null,
                    //   }}
                    >
                      <ListItem
                        button
                        className={
                          location.pathname === to
                            ? "active-div"
                            : "inActive-div"
                        }
                      >
                        <ListItemText onClick={() => onClose(false)}>
                          <div className="d-flex">
                            {/* <span className="mr-4 ml-md-2">
                              {location.pathname === to ? (
                                <img src={activeIcon} />
                              ) : (
                                <img src={iconName} />
                              )}
                            </span> */}

                            <span
                              className={
                                location.pathname === to
                                  ? "activeBar"
                                  : "inActiveBar"
                              }
                            >
                              {label}
                            </span>
                          </div>
                        </ListItemText>
                      </ListItem>
                    </div>
                  </NavLink>
                </>
              )
            )}
          </List>
          <span className={"inActiveBar px-3"} onClick={() => logoutUser()}>
            Logout
          </span>
        </div>
      </Drawer>
    </>
  );
};
export default MobileDrawer;
